import { AccessTime, ArrowForward, ArrowForwardIosOutlined, CancelOutlined, CheckOutlined, Close, LocationOnOutlined, PersonOutlineOutlined, Search, ShowChartOutlined, TaskAlt } from '@mui/icons-material'
import { Autocomplete, Avatar, Box, Button, Grid, InputAdornment, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { orderStatusColors } from '../../../Component/OrderStatusColors/orderStatusColors'
import { avatarColors } from '../../../Component/AvtarColors/AvtarColors';
import { paymentStatusColor } from '../../../Component/PaymentStatusColor/paymnetStatusColor';
import OrderDetails from './OrderDetails';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../Redux/store';
import { ApiGetOrders } from '../../../Core/Apicall';
import { Orders } from '../../../types/Orders';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';

function PendingApprovals() {
  const theme = useTheme();
  const naviget = useNavigate()
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));

  const [selectedOrder, setSelectedOrder] = useState<number | null>();
  const [status, setStatus] = React.useState<string | null>('PENDING');
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState<number>(-1)
  const rowsPerPage = 5;
  const { userDetails } = useSelector((state: RootState) => state.global)
  const [orders, setOrders] = useState<Orders[]>()
  const [serchItem, setSearchItem] = useState<string>('')
  const [debouncedSearch, setDebouncedSearch] = useState<string>('');
  const [refresh, setRefresh] = useState(false);
  
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(serchItem);
    }, 500);

    return () => clearTimeout(timer);
  }, [serchItem]);



  const getAvatarColor = (name: string = "") => {
    let total = 0;

    for (let i = 0; i < name.length; i++) {
      total += name.charCodeAt(i);
    }
    const index = total % avatarColors.length;

    return avatarColors[index];
  };


  const GetOrders = async () => {
    try {
      const data = `?offset=${page * rowsPerPage}&limit=${rowsPerPage}${debouncedSearch?.trim()?.length > 0 ? `&search=${debouncedSearch}` : ""}${status ? `&status=${status}` : ""}`
      const res = await ApiGetOrders(data)
      if (res?.status) {
        setOrders(res?.data)
        setTotal(res?.count)
        isPhone ? setSelectedOrder(null) : setSelectedOrder(res?.data?.[0]?.orderId)
        
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went worng")
    }
  }
  useEffect(() => {
    GetOrders()
  }, [page, debouncedSearch,status, refresh])

  const handleRefresh = () => {
    console.log("Refresh call")
    setRefresh(prev => !prev);
};
console.log("Refresh data", refresh)

  return (
    <Box className='p-lg-3 p-xl-4 p-2'>
      <Box className='d-flex mb-4  align-items-center justify-content-between'>
        <Box>
          <Typography variant='h5' className='fw-bold' sx={{ lineHeight: 'normal' }}>Order Approval</Typography>
          <Typography variant='body2'>Review and approve or reject client orders</Typography>
        </Box>
      </Box>
      {/* <Grid container spacing={1} className='my-2 mb-3'>
        <Grid size={{ xs: 6, md: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>Pending Approval</Typography>
              <Typography variant='h5'>1,248</Typography>
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['PENDING'].bg} !important` }}>
                <AccessTime sx={{ fontSize: '32px', color: `${orderStatusColors['PENDING'].color} !important`, }} />
              </Box>
            </Grid>
            <Grid size={12}>
              <Typography variant='caption'>Orders waiting for approval</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 6, md: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>Approved Today</Typography>
              <Typography variant='h5'>{312}</Typography>
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['COMPLETED'].bg} !important` }}>
                <TaskAlt sx={{ fontSize: '32px', color: `${orderStatusColors['COMPLETED'].color} !important` }} />
              </Box>
            </Grid>
            <Grid size={12}>
              <Typography variant='caption'>Total order value {Number("245600")?.toLocaleString("en-US", {
                style: "currency",
                currency: "INR",
              })}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 6, md: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>Rejected Today</Typography>
              <Typography variant='h5'>{456}</Typography>
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['REJECTED'].bg} !important` }}>
                <CancelOutlined className='text-red' sx={{ fontSize: '32px', color: `${orderStatusColors['REJECTED'].color} !important` }} />
              </Box>
            </Grid>
            <Grid size={12}>
              <Typography variant='caption'>Total order value {Number("245600")?.toLocaleString("en-US", {
                style: "currency",
                currency: "INR",
              })}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 6, md: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>Approval Rate</Typography>
              <Typography variant='h5'>{412}</Typography>
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['PROCESSING'].bg} !important` }}>
                <ShowChartOutlined sx={{ fontSize: '32px', color: `${orderStatusColors['PROCESSING'].color} !important` }} />
              </Box>
            </Grid>
            <Grid size={12}>
              <Typography variant='caption'>This month</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid> */}
      <Box className='card-bg border-10 p-2'>
        <Box className='custom-toggle border-bottom'>
          <ToggleButtonGroup
            value={status}
            exclusive
            onChange={(_, newStatus) => {
              if (newStatus !== null) {
                setStatus(newStatus);
              }
            }}
            aria-label="approval status"
          >
            <ToggleButton value="PENDING" aria-label="pending approvals">
              <Typography>Pending Approvals</Typography>
            </ToggleButton>

            <ToggleButton value="APPROVED" aria-label="approved">
              <Typography>Approved</Typography>
            </ToggleButton>

            <ToggleButton value="REJECTED" aria-label="rejected">
              <Typography>Rejected</Typography>
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        <Box className='d-flex align-items-center justify-content-between text-field  gap-2 p-3'>
          <TextField
            className='m-0 p-0'
            placeholder='Search by orderId,client...'
            sx={{ minWidth: { xs: "100%", md: '300px' } }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start" className='me-0'>
                    <Search fontSize="small" className='m-0 p-0' />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Box>
       {orders && orders?.length > 0 ? (<Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 4, lg: 3 }} className='d-flex flex-column' sx={{ height: '655px' }}>
            <Box className="d-flex flex-column gap-1" sx={{ flex: 1, overflow: 'auto' }}>
              {orders?.map((order, index) => {
                const isSelected = selectedOrder == order?.orderId;

                return (
                  <Box
                    key={order.orderId}
                    onClick={() => isPhone ? naviget(`/${userDetails?.role}/order-details/${order?.orderId}`) : setSelectedOrder(order?.orderId)}
                    className={`d-flex align-items-center gap-3 p-3 border-10 cursor-pointer ${isSelected
                      ? "border-main bg-second-light"
                      : "border"
                      }`}
                  >
                    <Avatar
                      sx={{
                        width: 32,
                        height: 32,
                        bgcolor: getAvatarColor(order.subClient?.companyName).bg,
                        color: getAvatarColor(order.subClient?.companyName).text,
                        fontSize: 14,
                        fontWeight: 700,
                      }}
                    >
                      {order?.subClient?.companyName?.split(" ")[0][0]}{order.subClient?.companyName?.split(" ")[1][0]}
                    </Avatar>

                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="body2"
                        className="fw-bold"
                      >
                        #{order.orderId}
                      </Typography>

                      <Typography
                        variant="caption"
                        className="d-block"
                      >
                        {order.subClient?.companyName}
                      </Typography>

                      <Typography
                        variant="caption"
                        className="d-block"
                      >
                        {Number(order.totalAmount)?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "INR",
                        })} (<span>{order.items?.length} Items</span>)
                      </Typography>

                      <Typography
                        variant="caption"
                        className="d-block"
                      >
                        {dayjs(order?.created_at).format("DD MMM YYYY HH:mm a")}
                      </Typography>
                    </Box>

                    <ArrowForwardIosOutlined
                      sx={{ fontSize: "16px" }}
                    />
                  </Box>
                );
              })}
            </Box>
            <Box className="p-3 d-flex justify-content-end">
              {total > rowsPerPage && (
                <Pagination
                  page={page + 1}
                  count={Math.ceil(total / rowsPerPage)}
                  onChange={(_, value) => {
                    setPage(value - 1);
                    setSelectedOrder(null);
                  }}
                  shape="rounded"
                  sx={{
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "var(--primary-color)",
                      color: "white",
                    },
                  }}
                  showFirstButton={false}
                  showLastButton={false}
                  siblingCount={1}
                  boundaryCount={1}
                />
              )}
            </Box>
          </Grid>
          <Grid size={{ xs: 'auto' }} className='border'></Grid>
          {selectedOrder && (
            <Grid size={{ xs: 12, md: 'grow' }} className='pe-3 overflow-auto' sx={{ height: '655px' }}>
              <OrderDetails orderId={selectedOrder} setRefresh={handleRefresh} />
            </Grid>
          )}
        </Grid>
        )
        :(
          <Box className='text-center my-5 py-5'>No Data Found</Box>
        )
        }
      </Box>
    </Box>
  )
}

export default PendingApprovals
